import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-monitored-train-sim',
  template: require('./monitored-train-sim.component.html'),
  styles: [require('./monitored-train-sim.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoredTrainSimComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
